import React, { useEffect, useState } from 'react';
import TablaDinamica from '../util/TablaDinamica';
import instanciaAxios, { esErrorPermiso } from '../../miscelaneo/instanciaAxios';
import { toast } from 'react-toastify';
import DockVerticalDerecha from '../estructura/DockVerticalDerecha';
import PlantillaModal from '../util/PlantillaModal';
import TablaTransferenciaInventario from '../util/tablas/TablaTransferenciaInventario';
import InputProductos from '../util/Inputs/InputProductos';
import FuncionesGenerales from '../util/FuncionesGenerales';
import SpinnerCargando from '../util/SpinnerCargando';
import { useContextoSesion } from '../../miscelaneo/ContextoSesion'; // Importa el hook del contexto
import { noEsFechaHoraFutura } from '../util/ValidacionesCampos';

function ProcesoTransferencia() {
    const [formData, setFormData] = useState({});
    const {usuario} = useContextoSesion();
    const { obtenerFechaHoraActual, formatearFechaHoraInput } = FuncionesGenerales();    
    const [sucursales, setSucursales] = useState([]);
    const [productos, setProductos] = useState([]);
    const [modo, setModo] = useState('creacion');
    const [editable, setEditable] = useState(true);
    const [transferenciaSeleccionada, SetTransferenciaSeleccionada] = useState(null);
    const [mostarModalTransferencia, setMostrarModalTransferencia] = useState(false);
    const [nombresProductos,setNombresProductos] = useState([]);
    const[cargando,setCargando] = useState(false);


    useEffect(() => {
        setEditable(modo === 'creacion');
        if (modo === 'ver') {
            SetTransferenciaSeleccionada(null);
            toast.info('Modo solo observación');
        } else if (modo === 'edicion') {
            SetTransferenciaSeleccionada(null);
            toast.info('Modo edición');
        }else if (modo === 'creacion') {
            SetTransferenciaSeleccionada(null);
            toast.info('Modo creación');
        } 
    }, [modo]);

    useEffect(() => {
        const fetchSucursales = async () => {
              setCargando(true);

            try {
                const response = await instanciaAxios.get('/miscelaneo/sucursal');
                setSucursales(response.data);
            } catch (error) {
                if (esErrorPermiso(error)) return;
                console.error('Error fetching sucursales:', error);
                toast.error('Error al cargar las sucursales');
            } finally{
                setCargando(false)
            }
        };
        setFormData((prev) => ({
            ...prev,    
            fecha_hora: obtenerFechaHoraActual(),
            usuario: usuario.nombre +' '+ (usuario.apellido? usuario.apellido : '')

         }))
        
        fetchSucursales();

    }, []);


    const handleChange = (e) => {
        const { id, value, type, checked } = e.target;

        if(id == 'id_sucursal_origen'){
            if (formData.productos_transferencia?.length > 0) {
                toast.error('Si necesita cambiar la sucursal de origen, debe eliminar los detalles de la transferencia.')
                return
            }
        }

        // Validar que la sucursal de origen sea diferente a la sucursal de destino
        if (id === 'id_sucursal_destino' && value && formData.id_sucursal_origen) {
            if (String(value) === String(formData.id_sucursal_origen)) {
                toast.error('La sucursal de destino debe ser diferente a la sucursal de origen');
                return;
            }
        }
        
        if (id === 'id_sucursal_origen' && value && formData.id_sucursal_destino) {
            if (String(value) === String(formData.id_sucursal_destino)) {
                toast.error('La sucursal de origen debe ser diferente a la sucursal de destino');
                return;
            }
        }

        setFormData((prev) => ({
            ...prev,
            [id]: type === 'checkbox' ? checked : value,
        }));
    };

    const campos = [
        {
            id: "id_sucursal_origen",
            type: "select",
            label: "Sucursal de origen",
            placeholder: "Seleccione sucursal de origen",
            seccion: "Transferencia de inventario",
            opciones: sucursales.map(s => ({ label: s.descripcion, value: s.id_sucursal })),
            required: true
        },
        {
            id: "id_sucursal_destino",
            type: "select",
            label: "Sucursal de destino",
            placeholder: "Seleccione sucursal de destino",
            seccion: "Transferencia de inventario",
            opciones: sucursales.map(s => ({ label: s.descripcion, value: s.id_sucursal })),
            required: true
        },
        {
            id: "fecha_hora",
            type: "datetime-local",
            label: "Fecha y hora",
            placeholder: "Fecha y hora",
            default: "now",
            seccion: "Transferencia de inventario",
            required: true
        },
                {
            id: "usuario",
            type: "text",
            label: "Usuario",
            placeholder: "Usuario",
            seccion: "Transferencia de inventario",
            disabled: true,
            required: false
        },
        {
            id: "comentario",
            type: "textarea",
            label: "Comentario",
            placeholder: "Comentario",
            seccion: "Comentario de la transferencia",
            required: false
        }

    ];

    const camposFiltrados = campos;

    const camposPorSeccion = camposFiltrados.reduce((acc, campo) => {
        if (!acc[campo.seccion]) acc[campo.seccion] = [];
        acc[campo.seccion].push(campo);
        return acc;
    }, {});

    async function SubmitTransferencia() {
        if (cargando) return;
        // console.log('Datos del formulario:', formData);

        // return;
        const errores = [
            { cond: !formData.id_sucursal_origen, msg: 'El campo sucursal de origen es obligatorio' },
            { cond: !formData.id_sucursal_destino, msg: 'El campo sucursal de destino es obligatorio' },
            { cond: !formData.fecha_hora, msg: 'El campo fecha y hora es obligatorio' },
            { cond: !noEsFechaHoraFutura(formData.fecha_hora), msg: 'La fecha y hora no pueden ser mayores a la actual' },
            { cond: formData.id_sucursal_origen && formData.id_sucursal_destino && String(formData.id_sucursal_origen) === String(formData.id_sucursal_destino), msg: 'La sucursal de origen debe ser diferente a la sucursal de destino' },
            { cond: !formData.productos_transferencia || formData.productos_transferencia.length === 0, msg: 'Debe agregar al menos un producto a la transferencia' },
        ];

        for (let error of errores) {
            if (error.cond) {
                toast.error(error.msg);
                return;
            }
        }

        // Validar productos individualmente
        for (let producto of formData.productos_transferencia) {
            // Buscar el nombre del producto en el array nombresProductos
            const nombreProducto = nombresProductos.find(
                (p) => String(p.value) === String(producto.id_producto)
            )?.label || producto.descripcion || 'sin nombre';
            
            const erroresProducto = [
                { cond: !producto.cantidad || producto.cantidad <= 0, msg: `La cantidad del producto "${nombreProducto}" debe ser mayor a 0` },
                { cond: producto.existencia_actual === 0, msg: `El producto "${nombreProducto}" no tiene existencia en la sucursal de origen` },
                { cond: producto.existencia_actual !== undefined && producto.existencia_actual !== null && producto.cantidad > producto.existencia_actual, msg: `La cantidad del producto "${nombreProducto}" (${producto.cantidad}) excede la existencia disponible en la sucursal de origen (${producto.existencia_actual})` },
            ];

            for (let error of erroresProducto) {
                if (error.cond) {
                    toast.error(error.msg);
                    return;
                }
            }
        }

        try {
            let id_transferencia_ = formData.id_transferencia;
            const payload = formData;

            if (modo === 'ver') {
                toast.info('Se encuentra en modo solo observación, no se puede guardar nada');
                return;
            }

            setCargando(true);

            if (modo === 'creacion') {
                const respuesta = await instanciaAxios.post('/inventario/transferencia', payload);
                toast.success(respuesta.data.mensaje);
                id_transferencia_ = respuesta.data.id_transferencia;

                setFormData(prev => ({
                    ...prev,
                    id_transferencia: id_transferencia_,
                }));

                toast.success('Transferencia registrada con éxito');
            }

            if (modo === 'edicion') {
                const payloadUpdate = {
                    id_transferencia_sucursal: formData.id_transferencia_sucursal,
                    comentario: formData.comentario
                };
                const response = await instanciaAxios.put('/inventario/transferencia', payloadUpdate);
                toast.success(response.data.mensaje);
                toast.success('Transferencia editada con éxito');
            }

            setModo('ver');
        } catch (error) {
            if (esErrorPermiso(error)) return;
            toast.error('Error al guardar la transferencia');
            toast.error(error.response.data.mensaje);
            console.error(error);
        } finally {
            setCargando(false);
        }
    }

     async function handleBotonBuscar() {
    try {
      setMostrarModalTransferencia(true)
      setModo('ver');
    } catch (error) {
      console.log(error);
    }
  }

   async function handleBotonEditar() {
    try {
      setMostrarModalTransferencia(true)
      setModo('edicion');
    } catch (error) {
      console.log(error);
    }
  }

    async function handleBotonCrear() {
    try {
      setModo('creacion');
      setFormData({
        id_sucursal_origen: '',
        id_sucursal_destino: '',
        comentario: '',
        fecha_hora: formatearFechaHoraInput(obtenerFechaHoraActual()),
        usuario: usuario.nombre +' '+ (usuario.apellido? usuario.apellido : ''),
        productos_transferencia: [],
        id_transferencia_sucursal: ''
      });
    } catch (error) {
      console.log(error);
    }
  }

  async function handleSeleccionarTransferencia(id_transferencia) {
    setMostrarModalTransferencia(false);
    try {
        const respuesta = await instanciaAxios.get('/inventario/transferencia/' + id_transferencia);
        const data = respuesta.data;

        console.log('Datos de transferencia:', data);

        // No consultar existencias para modo ver/edición
        const productosTransferencia = data.productos_transferencia || [];

        setFormData({
            id_sucursal_origen: data.id_sucursal_origen || '',
            id_sucursal_destino: data.id_sucursal_destino || '',
            comentario: data.comentario || '',
            fecha_hora: formatearFechaHoraInput(data.fecha_hora) || '',
            usuario: data.usuario || '',
            productos_transferencia: productosTransferencia, 
            id_transferencia_sucursal: id_transferencia
        });
        setNombresProductos(productosTransferencia.map((producto) => ({label: producto.descripcion, value: producto.id_producto})));
    } catch (error) {
        console.error('Error al obtener transferencia:', error);
    }
    
  }


        
    return (
        cargando?(
            <SpinnerCargando/>
        ) :(
        <div className="bg-gray-200 min-h-screen">
            <div className="flex justify-center py-10">
                <div className="bg-gray-100 bg-opacity-90 rounded-xl border border-gray-100 p-12 w-full max-w-7xl mx-10">
                    <form className="flex flex-col gap-8">
                        <div className="space-y-1">
                            <h1 className="font-cascadia font-bold text-2xl">Transferencia de inventario</h1>
                            <p className="text-gray-500">
                                Registre y gestione las transferencias de productos entre sucursales para mantener un control preciso del inventario distribuido.
                            </p>
                        </div>
                        {Object.entries(camposPorSeccion).map(([titulo, campos]) => (
                            <div key={titulo}>
                                <h2 className="text-lg font-semibold mb-4">{titulo}</h2>
                                <div className="grid gap-4 grid-cols-[repeat(auto-fit,_minmax(230px,_1fr))]">
                                    {campos.map((campo) => (
                                        <div key={campo.id} className="flex flex-col">
                                            {campo.custom ? (
                                                <div className="flex flex-col">
                                                    <label htmlFor={campo.id} className="text-sm font-medium text-gray-600 mb-1 flex items-center gap-1">
                                                        {campo.label}
                                                        {campo.required && <span className="text-red-500">*</span>}
                                                    </label>
                                                </div>
                                            ) : campo.type === "checkbox" ? (
                                                <label
                                                    htmlFor={campo.id}
                                                    className={`cursor-pointer px-3 py-2 rounded-xl border text-sm font-medium text-center ${
                                                        formData[campo.id]
                                                            ? 'bg-color-secundario text-white border-color-secundario'
                                                            : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100'
                                                    }`}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id={campo.id}
                                                        disabled={!editable}
                                                        checked={formData[campo.id] || false}
                                                        onChange={handleChange}
                                                        className="sr-only"
                                                    />
                                                    {campo.label}
                                                </label>
                                            ) : campo.type === "select" ? (
                                                <>
                                                    <label htmlFor={campo.id} className="text-sm font-medium text-gray-600 mb-1 flex items-center gap-1">
                                                        {campo.label}
                                                        {campo.required && <span className="text-red-500">*</span>}
                                                    </label>
                                                    <select
                                                        id={campo.id}
                                                        value={formData[campo.id] || ""}
                                                        onChange={handleChange}
                                                        disabled={!editable}
                                                        className={`w-full p-2 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                                                            campo.required && editable
                                                                ? 'border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100' 
                                                                : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
                                                        }`}
                                                    >
                                                        <option value="">Seleccione una opción</option>
                                                        {campo.opciones?.map((option) => (
                                                            <option key={option.value} value={option.value}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </>
                                            ) : campo.type === "textarea" ? (
                                                <>
                                                    <label htmlFor={campo.id} className="text-sm font-medium text-gray-600 mb-1 flex items-center gap-1">
                                                        {campo.label}
                                                        {campo.required && <span className="text-red-500">*</span>}
                                                    </label>
                                                    <textarea
                                                        id={campo.id}
                                                        disabled={!editable && (modo !== 'edicion' || campo.id !== 'comentario')}
                                                        className={`w-full p-2 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                                                            campo.required && (editable || (modo === 'edicion' && campo.id === 'comentario'))
                                                                ? 'border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100' 
                                                                : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
                                                        }`}
                                                        value={formData[campo.id]}
                                                        onChange={handleChange}
                                                        placeholder={campo.placeholder}
                                                        rows={3}
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    <label htmlFor={campo.id} className="text-sm font-medium text-gray-600 mb-1 flex items-center gap-1">
                                                        {campo.label}
                                                        {campo.required && <span className="text-red-500">*</span>}
                                                    </label>
                                                    <input
                                                        type={campo.type}
                                                        id={campo.id}
                                                        disabled={campo.disabled || !editable}
                                                        className={`w-full p-2 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                                                            campo.required && editable
                                                                ? 'border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100' 
                                                                : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
                                                        }`}
                                                        value={formData[campo.id] || ""}
                                                        onChange={handleChange}
                                                        placeholder={campo.placeholder}
                                                    />
                                                </>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </form>
                    <DockVerticalDerecha 
                        handleBotonBuscar={() => handleBotonBuscar()}
                        handleBotonGuardar={(e) => SubmitTransferencia(e)}
                        handleBotonEditar={() => handleBotonEditar()}
                        handleBotonCrear={() => handleBotonCrear()}
                    />

                    <PlantillaModal
                        mostrar={mostarModalTransferencia}
                        onClose={() => setMostrarModalTransferencia(false)}
                    >
                        <TablaTransferenciaInventario
                            descripcion={'Seleccione la transferencia para ver o editar.'}
                            setTransferenciaSeleccionada={handleSeleccionarTransferencia}    />
                        
                    </PlantillaModal>

                    <div className="mt-4">
                        <h2 className="text-lg font-semibold mb-2">Productos en el inventario</h2>
                        <TablaDinamica
                            modoTablaDinamica='TransferenciaInventario'
                            tipo_producto={[1]}
                            tipo_tabla_producto='inventarioPorSucursal'
                            id_sucursal_tabla_producto={formData.id_sucursal_origen}

                            editable={editable}
                            value={formData.productos_transferencia || []}
                            fields={modo === 'creacion' ? [
                                {
                                    name: "id_producto",
                                    label: "Producto",
                                    placeholder: "Seleccione un producto",
                                    type: "producto",
                                    unico: true
                                },
                                {
                                    name: "cantidad",
                                    label: "Cantidad a transferir",
                                    placeholder: "Cantidad a transferir",
                                    type: "number",
                                },
                                {
                                    name: "existencia_actual",
                                    label: "Existencia en sucursal de origen",
                                    placeholder: "Existencia en sucursal de origen",
                                    type: "number",
                                    disabled: true
                                },
                            ] : [
                                {
                                    name: "id_producto",
                                    label: "Producto",
                                    placeholder: "Producto",
                                    type: "producto",
                                    unico: true
                                },
                                {
                                    name: "cantidad",
                                    label: "Cantidad transferida",
                                    placeholder: "Cantidad transferida",
                                    type: "number",
                                },
                            ]}
                            onChange={(data) => 
                                setFormData((prev) => ({
                                    ...prev,
                                    productos_transferencia: data
                                }))
                            }
                            camposRequeridos={['id_producto', 'cantidad']}
                            setNombresProductos={setNombresProductos}
                            nombresProductos={nombresProductos}
                        />
                    </div>
                </div>
            </div>
        </div>
        )
    );
}

export default ProcesoTransferencia;
